import { RootState } from '../store'

export const messagessStates = (state: RootState) => state.messages
